import { Backdrop } from '@mui/material'
import React from 'react'
import LoaderImg from "../../Images/Loading.gif";

const Loader = (props) => {
    const { open, handleClose } = props;
  return (
    <div className="backdrop">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
        className="backdrop-back"
      >
        <div className="backdrop-img">
          <img src={LoaderImg} alt="" />
        </div>
      </Backdrop>
    </div>
  )
}

export default Loader